// view.js
// view component: manages group components
// some groups could be dynamically multiple

import React from 'react'
import { compact, flatten, includes, keys, isEmpty, get } from 'lodash'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { andList, orList, values } from 'prelude-ls'
import * as Actions from './redux/actions'
import EventListener, {withOptions} from 'react-event-listener'

import { getCurrentRouteId, validUserLogin } from './lib/utils'
import Group from './group.js'

class View extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      id       : this.props.id, // view ID
      locale   : get(this.props, 'locale', 'en'),
      schema   : get(this.props, 'schema'),
      // classes  : get(this.props,'AXGClasses.view', 'container'),
      classes  : get(this.props, 'schema.classes', 'container'),
      classesHeader : get(this.props, ['AXGClasses','view.header']),
      classesFooter : get(this.props, ['AXGClasses','view.footer']),
      protected: get(this.props, 'schema.protected', false),
    }
  }

  componentWillReceiveProps(nextProps) {
    var component = this
    component.setState({
      id    : nextProps.id,
      locale: nextProps.locale,
      schema: nextProps.schema,
      classes  : get(nextProps, 'schema.classes'),
      protected: get(nextProps, 'schema.protected', false),
      loginCheckerHandle: null,
    })
  }

  componentDidUpdate() {
    if (get(this.props,'AXGOptions.material-design')) {
      $.material.init()
    }
  }

  handleKeyPress(e) {
    console.log(`key pressed: ${e.key}`)
  }

  render() {
    const [ c, p, s ] = [ this, this.props, this.state ]
    let { locale, schema } = this.state
    // var title = get(schema, 'title.long') || get(schema, 'title.short') || get(schema, 'title')
    let layoutGroups = compact(flatten(get(schema,'groups.layout',[])))
    // console.log(`layoutGroups: ${JSON.stringify(layoutGroups)}`)
    // TODO: give schema example / format spec in this source file

    // FIXME: get signinViewIds from props
    const signinRouteIds = [ 'signin', '' ]
    const currentRouteId = getCurrentRouteId()
    const isSigninRoute = includes(signinRouteIds, currentRouteId)
    const isSigninView = this.state.id == 'signin'

    let canRender = false
    // anything is true
    const renderConditions = {
      open: ! s.protected,
      protected_but_valid_login: s.protected && validUserLogin(),
    }
    const noRenderConditions = {
      non_signin_view_but_in_signin_route: (isSigninRoute && !isSigninView)
    }
    // console.info(`__ auth __ renderConditions: ${s.id}: ${JSON.stringify(renderConditions)}`)
    // console.info(`__ auth __ noRenderConditions: ${s.id}: ${JSON.stringify(noRenderConditions)}`)
    const canRenderCheck = orList(values(renderConditions))
    const cannotRenderCheck = orList(values(noRenderConditions))

    canRender = !cannotRenderCheck && canRenderCheck

    return (
      canRender
      ? <div className={this.state.classes}>
          {
            (layoutGroups.length > 0) &&
            layoutGroups.map(
              (group) =>  {
                // group item accepts both string or object (assumes first key to be string)
                // console.log(`group: ${group}`)
                var groupName = typeof group === 'object' ? keys(group)[0] : group
                // handles whether the group is visible (show === true) or not
                // TODO: allows a group display status to depend on an array of conditions
                // Need a way to specify OR / AND etc...
                // e.g. show:
                //        - this.main.makes: MA002
                //        - this.controller.country: US
                var show = true // default
                var showCondition = typeof group === 'object'
                    ? get(group, [groupName, 'show'], null)
                    : null
                // console.info(`... group.js: ${this.props.id}: showCondition: ${JSON.stringify(showCondition)}`)

                if (showCondition) {
                  // TODO: REFACTOR: same as show condition check in item.js
                  if (typeof showCondition === 'boolean') {
                    show = showCondition
                  } else if (typeof showCondition === 'string') {
                    // TODO: generic handling of pre-defined conditions
                    // account.authenticated
                    // REVIEW: untimely update incidentally solved by passing down props: account from root component
                    if (showCondition === 'account.authenticated') {
                      // let signedIn = localStorage.getItem('Appxigon.loginToken') !== null
                      let signedIn = validUserLogin()
                      let currentPathName = window.appxigon.history.getCurrentLocation().pathname
                      show = andList([
                        signedIn,
                        currentPathName != `/${get(this.props.appxigonAccountConfig, 'signin-view')}`
                      ])
                      // console.info(`Appxigon.loginToken: ${localStorage.getItem('Appxigon.loginToken')}`)
                      // console.info(`account.authenticated check: ${show}`)
                      // show = this.state.account.loginToken !== null
                    }
                    if (showCondition === 'account.rejected') {
                      // APOLLO-TODO: proper reject condition from REDUX
                      // show = localStorage.getItem('Appxigon.loginToken') !== null
                      show = !validUserLogin()
                    }
                  } else {
                    // object of conditions
                    // TODO: handle multiple conditions
                    var conditionKey = Object.keys(showCondition)[0]
                    stateRefKey = normalizeSchemaKey(conditionKey, this.props.AXGKey)
                    show = (get(this.props.appxigonState, [stateRefKey]) === stateRefVal)
                            ? true
                            : false
                  }
                }

                // overwrite global Group classes def
                var groupClasses = typeof group === 'object' ? get(group, `${groupName}.classes`) : null
                // console.log(`group / groupClasses: ${JSON.stringify(group)} / ${JSON.stringify(groupClasses)}`)
                var collapsable = false // default
                collapsable = typeof group === 'object'
                    ? get(group, [groupName, 'collapsable'], false)
                    : false
                var removable = false // default
                removable = typeof group === 'object'
                    ? get(group, [groupName, 'removable'], false)
                    : false
                // If the group use alias, the actual schema passing to Group should change accordingly
                var realGroupName = groupName
                // console.log(`group: ${JSON.stringify(group)}`)
                if (typeof group === 'object') {
                  realGroupName = get(group, [groupName,'alias-of'], groupName)
                }
                // console.log(`realGroupName: ${realGroupName}`)

                return (
                  !isEmpty(group)
                  && <Group
                      env={this.props.env}
                      key={`${this.props.id}.${groupName}`}
                      id={groupName}
                      locale={locale}
                      account={this.props.account}
                      collapsable={collapsable}
                      removable={removable}
                      show={show}
                      classes={groupClasses}
                      AXGKey={`${this.props.id}.${groupName}`}
                      AXGClasses={this.props.AXGClasses}
                      AXGOptions={this.props.AXGOptions}
                      AXGDataSource={this.props.AXGDataSource}
                      schema={this.state.schema.groups[realGroupName]}/>
                )

              }
            )
          }
        </div>
      :
      <div className={this.props.isHeader && 'hidden'}>
        Login required!
      </div>
    )
  }

}

function mapStateToProps(state) {
  return {
    appxigonState: state.AXGState,
    // appxigonView:  state.AXGView,
    appxigonAccountConfig: get(state.AXGSchema, 'schema.account')
  }
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch)
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View)



// WEBPACK FOOTER //
// ./view.js